<template>
  <div class="helpDetail">
    <div
      class="publicTitle display-flex justify-content-space-between align-items-center"
    >
      <h5 class="h5" @click="handleBack">
        <img src="../../assets/img/backIcon.png" alt /> 返回
      </h5>
    </div>
    <div class="detail" v-html="detail"></div>
  </div>
</template>

<script>
import { postData, showLoading, EventBus } from "../../assets/api/api.js";
export default {
  name: "HelpDetail",
  components: {},
  data() {
    return {
      detail: {},
    };
  },
  created() {
    if (this.$route.params.content) {
      sessionStorage.setItem("content", this.$route.params.content);
    }
    this.detail =
      this.$route.params.content || sessionStorage.getItem("content");
  },

  mounted() {
    EventBus.$on("handleChangeHelp", (content) => {
      sessionStorage.setItem("content", content);
      this.detail = content;
    });
  },
  computed: {},
  methods: {
    handleBack() {
      this.$router.back();
    },
  },
};
</script>

<style lang="scss" scoped>
.helpDetail {
  .h5 {
    cursor: pointer;
  }
  .detail {
    margin-top: 30px;
    min-height: 450px;
  }
}
</style>
